export default __webpack_public_path__ + "static/library.logo-861d7e80a84134b8f5b4a9888f044ef2.png";